import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
/* empty css                    */
const AgeGroupButton = ({
  text,
  isSelected = false,
  className,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  "button",
  {
    ...rest,
    className: classnames("appointments-age-group-button", className, { isSelected })
  },
  text ? /* @__PURE__ */ React.createElement(Text, { className: "button__text", variant: "caption-head" }, text) : null
);
export {
  AgeGroupButton as default
};
//# sourceMappingURL=AgeGroupButton.js.map
